import React, { useContext } from "react";
import Button from "@mui/material/Button";
import LooksOneSharpIcon from "@mui/icons-material/LooksOneSharp";
import LooksTwoSharpIcon from "@mui/icons-material/LooksTwoSharp";
import FlashingLiveIndicator from "./FlashingLiveIndicator";
import { NowPlayingContext } from "./NowPlayingProvider";

const LiveIndicator = () => {
  const { liveStatuses } = useContext(NowPlayingContext);

  return (
    <div style={{ marginBottom: "1rem", display: "flex", alignItems: "center", gap: "1rem" }}>
      {liveStatuses.wssr && (
        <div key="wssr" style={{ display: "flex", alignItems: "center" }}>
          <Button
            size="small"
            color="primary"
            style={{ pointerEvents: "none" }}
            endIcon={<LooksOneSharpIcon />}
          >
            Deck
          </Button>
          <FlashingLiveIndicator station="wssr" />
        </div>
      )}

      {liveStatuses.wssr_node_2 && (
        <div key="wssr_node_2" style={{ display: "flex", alignItems: "center" }}>
          <Button
            size="small"
            color="secondary"
            style={{ pointerEvents: "none" }}
            endIcon={<LooksTwoSharpIcon />}
          >
            Deck
          </Button>
          <FlashingLiveIndicator station="wssr_node_2" />
        </div>
      )}
    </div>
  );
};

export default LiveIndicator;
